export default class MenuServices {
    constructor(containerSelector = '.super-menu-services') {
        this.jQuerycontainer = jQuery(containerSelector);
        this.jQuerytabs = this.jQuerycontainer.find('.tab-column__item:not(.highlight)');
        this.jQuerycontents = this.jQuerycontainer.find('.list-item-column__content');

        this.init();
    }

    init() {
        this.bindEvents();
    }

    bindEvents() {
        this.jQuerytabs.on('click', (event) => this.handleTabClick(event));
        this.handleHover();
    }

    handleTabClick(event) {
        const jQueryclickedTab = jQuery(event.currentTarget);
        const tabId = jQueryclickedTab.data('tab-id');

        this.jQuerytabs.removeClass('active');
        jQueryclickedTab.addClass('active');

        this.jQuerycontents.removeClass('active');
        this.jQuerycontents
            .filter(`[data-content-tab-id="${tabId}"]`)
            .addClass('active')
            .siblings()
            .removeClass('active');
    }

    handleHover() {
        const menuServicesItem = jQuery(".services-menu");
        const superMenuServices = jQuery(".super-menu-services-container");

        menuServicesItem.add(superMenuServices).on("mouseover", function () {
            superMenuServices.addClass("active");
        });

        menuServicesItem.add(superMenuServices).on("mouseout", function () {
            superMenuServices.removeClass("active");
        });

    }

}
